import { useEffect, useState } from 'react';

export const useDelay = (time: number = 0) => {
  const [delay, setDelay] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setDelay(false);
    }, 1000 * time);
  }, [time]);
  return delay;
};
